import styled, { css } from "styled-components";

// components
import Flexbox from "core/Flexbox";
import colors from "core/colors";
import { focusOutline } from "core/links";
import BodyText from "core/BodyText";
import { BorderBottomLinkStyle, CustomFocusStyle } from "core/Typography";
import FormInput from "core/FormInput";
import breakpoints from "core/breakpoints";
import { bold, medium } from "core/fontStyles";
import Add from "core/ReusableIcons/Add";
import Minus from "core/ReusableIcons/Minus";

// helpers
import { convertPxToRem } from "frontend/components/helpers";
import {
    handleBottomSpacing,
    handleTopSpacing
} from "js/helpers/spacingAndFonts";

export const CodeContainer = styled(Flexbox).attrs({
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
})`
    border-top: ${convertPxToRem({ px: 1 })} solid ${colors.concrete};
    border-bottom: ${convertPxToRem({ px: 1 })} solid ${colors.concrete};

    ${handleTopSpacing({ topSpacing: "lg" })}

    ${({ bottomSpacing }) =>
        bottomSpacing &&
        css`
            ${handleBottomSpacing({ bottomSpacing: "lg" })}
        `}
`;

export const SuccessContainer = styled(Flexbox).attrs({
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
})`
    width: ${convertPxToRem({ px: 290 })};
    padding-top: ${convertPxToRem({ px: 12 })};
    padding-left: ${convertPxToRem({ px: 15 })};
    padding-bottom: ${convertPxToRem({ px: 12 })};
    padding-right: ${convertPxToRem({ px: 15 })};

    background-color: ${colors.mist};
    border-radius: ${convertPxToRem({ px: 5 })};
`;

export const PromotionAppliedText = styled(BodyText)`
    ${bold};
    padding-right: ${convertPxToRem({ px: 8 })};

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        padding-right: ${convertPxToRem({ px: 4 })};
    }
`;

export const SavingsText = styled(BodyText)`
    padding-left: ${convertPxToRem({ px: 8 })};
    ${medium}
`;

export const PromoCodeSubmitForm = styled.form`
    display: flex;

    ${FormInput} {
        margin-right: ${convertPxToRem({ px: 16 })};

        @media (max-width: ${breakpoints.tablet.rem}) {
            width: 90%;
        }
    }
`;

export const AddCodeText = styled(BodyText)`
    &:hover {
        color: ${colors.ink};
        border-color: ${colors.ink};
    }

    ${BorderBottomLinkStyle}
    ${CustomFocusStyle}
`;

export const ButtonWrapper = styled.button`
    cursor: pointer;
    border: 0;
    padding: 0;
    margin: 0;
    background: none;
    &:focus {
        outline: none;
        border: none;
        ${focusOutline}
    }

    ${Add} {
        margin-right: ${convertPxToRem({ px: 16 })};
    }
`;

export const PromoContainer = styled(Flexbox).attrs({
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
})`
    width: ${convertPxToRem({ px: 200 })};
`;

export const MinusContainer = styled(ButtonWrapper)`
    padding-top: ${convertPxToRem({ px: 10 })};
    height: ${convertPxToRem({ px: 16 })};

    ${Minus} {
        margin-right: ${convertPxToRem({ px: 16 })};
    }
`;
